import React, { useEffect, useState } from "react";
import { YhPageHeader } from "@/components/YhPageHeader";
import { ISearchField, ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { ioFlagDs, tradeTypeDs, billCancelStatusDs } from "@/types/FmsDs";
import { creditFlagDs } from "../../../account/AccountService";
import { useBillSupplierModel } from "../billSupplierModel";
import useGlobalModel from "@/model/globalModel";

export function PageHeader() {
    const {
        orgDs,
        beDs,
        // payMethodDs,
        searchParam,
        resetSearchParam,
        updateSearchParam,
        loadData
    } = useBillSupplierModel();

    const { fetchSupplierList, accountTypeDs, appDs } = useGlobalModel(() => []);

    const searchFields: ISearchField[] = [
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "系统分支",
            fieldName: "branch",
            size: "small",
            options: appDs,
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "账单编码",
            fieldName: "code",
            size: "small",
        },
        {
            type: SearchTypeEnum.TreeSelect,
            xxl: 4,
            span: 4,
            placeholder: "从属机构",
            fieldName: "orgCode",
            size: "small",
            treeDs: orgDs,
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "销售实体",
            fieldName: "beCode",
            size: "small",
            options: beDs,
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     placeholder: "授信类型",
        //     fieldName: "creditFlag",
        //     size: "small",
        //     options: creditFlagDs(),
        // },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "供应商",
        //     fieldName: "partnerCode",
        //     size: "small",
        //     options: supplierDs,
        // },
        {
            type: SearchTypeEnum.AsyncSelect,
            xxl: 4,
            span: 4,
            placeholder: "供应商",
            fieldName: "partnerCode",
            size: "small",
            selectfetchList: fetchSupplierList,
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "单据类型",
            fieldName: "tradeTypeCode",
            size: "small",
            options: tradeTypeDs,
        }]
    const searchMoreFields: ISearchField[] = [
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "账户类型",
            fieldName: "accountTypeCode",
            size: "small",
            options: accountTypeDs,
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "单据编号",
            fieldName: "tradeCode",
            size: "small",
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     placeholder: "支付方式",
        //     fieldName: "payType",
        //     size: "small",
        //     options: payMethodDs,
        // },
        {
            type: SearchTypeEnum.RangePicker,
            xxl: 8,
            span: 8,
            placeholder: "起止",
            fieldName: "time",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "收支标识",
            fieldName: "ioFlag",
            size: "small",
            options: ioFlagDs,
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "账户编码",
            fieldName: "accountCode",
            size: "small",
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "状态",
            fieldName: "status",
            size: "small",
            options: [
                { label: "初始", value: "0" },
                { label: "已记账", value: "1" },
                { label: "已核销", value: "2" }
            ],
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "取消状态",
            fieldName: "cancelStatus",
            size: "small",
            options: billCancelStatusDs,
        },

    ]

    return (
        <YhPageHeader
            title="供应商账单"
            searchValues={searchParam as ISearchValue}
            searchMoreFields={searchMoreFields}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}